import { useCallback, useState } from "react";
import HeroSlider from "./HeroSlider";
import HeroVideo from "./HeroVideo";
import "./Hero1.css";
import HeroFilters from "./Herofilter";

// The hero is a single continuous reel:
//   intro video -> slide 1 ... slide N (ending with the Omoka na Zetech
//   banner) -> back to the video -> and so on.
// The left/right arrows drive that same reel in both directions, so the
// visitor can step back from the first slide into the video, or jump from
// the video straight into the last slide.
export default function Hero() {
    const [showVideo, setShowVideo] = useState(true);
    // Which slide the slider should open on when the video hands over.
    // -1 means "the last slide" (used when stepping backwards from the video).
    const [entrySlide, setEntrySlide] = useState(0);
    // Remount key so the video restarts cleanly on every loop.
    const [videoRun, setVideoRun] = useState(0);
    // Remount key so re-entering the slider always honors `entrySlide`.
    const [sliderRun, setSliderRun] = useState(0);

    const openSlider = useCallback((index) => {
        setEntrySlide(index);
        setSliderRun((n) => n + 1);
        setShowVideo(false);
    }, []);

    // Video finished (or was skipped) -> start at the first slide.
    const handleVideoEnd = useCallback(() => {
        openSlider(0);
    }, [openSlider]);

    // Arrow "next" while the video is on screen -> first slide.
    const handleVideoNext = useCallback(() => {
        openSlider(0);
    }, [openSlider]);

    // Arrow "previous" while the video is on screen -> last slide.
    const handleVideoPrev = useCallback(() => {
        openSlider(-1);
    }, [openSlider]);

    // Last slide finished, or the visitor stepped back off slide 1.
    const backToVideo = useCallback(() => {
        setVideoRun((n) => n + 1);
        setShowVideo(true);
    }, []);

    return (
        <>
            <section className={`hero ${showVideo ? "hero--video" : "hero--slider"}`}>
                {showVideo ? (
                    <HeroVideo
                        key={videoRun}
                        onVideoEnd={handleVideoEnd}
                        onNext={handleVideoNext}
                        onPrev={handleVideoPrev}
                    />
                ) : (
                    <HeroSlider
                        key={sliderRun}
                        initialIndex={entrySlide}
                        onCycleEnd={backToVideo}
                        onRequestVideo={backToVideo}
                    />
                )}

                <div className="overlay"></div>
            </section>

            <HeroFilters />
        </>
    );
}
